import * as React from "react";
import styled from "styled-components";
import { Icon } from "components/common/index";
import { DropdownButton } from "components/bootstrap";
export const MoreActionsIcon = ({ size = void 0 }) => /* @__PURE__ */ React.createElement(Icon, { name: "more_horiz", size });
const StyledDropdownButton = styled(DropdownButton)`
  ${({ $transparent }) => $transparent ? "background-color: transparent;" : ""}
`;
export const MoreActionsMenu = ({
  "aria-label": ariaLabel,
  size = "xs",
  bsStyle = void 0,
  children = void 0,
  className = void 0,
  id = void 0,
  keepMounted = void 0,
  pullRight = void 0,
  title = "More Actions",
  solid = false
}) => /* @__PURE__ */ React.createElement(
  StyledDropdownButton,
  {
    $transparent: !solid,
    "aria-label": ariaLabel,
    bsStyle,
    buttonTitle: title,
    className,
    id,
    keepMounted,
    noCaret: true,
    pullRight,
    title: /* @__PURE__ */ React.createElement(MoreActionsIcon, { size }),
    withinPortal: true
  },
  children
);
